import { jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { memo } from "react";
import { getChipColor } from "../utils/product-card.functions.es.js";
import Grid from "../../../../node_modules/@mui/material/Grid/Grid.es.js";
import { Chip } from "../../chip/chip.es.js";
function ProductCardChipBuilder({
  accentColor,
  disabled,
  badge
}) {
  return /* @__PURE__ */ jsx(Grid, { item: true, xs: 12, children: /* @__PURE__ */ jsx(Chip, { color: getChipColor(accentColor, disabled), label: badge, variant: "outlined", size: "small", disabled, "data-testid": "product-card-chip" }) });
}
const ProductCardChip = memo(ProductCardChipBuilder);
export {
  ProductCardChip
};
//# sourceMappingURL=product-card-chip.es.js.map
